import * as ng from 'angular';
import * as nggt from 'angular-gettext';
import * as _ from 'underscore';

import * as moment from 'moment';
import 'moment-timezone';

import { EventDetail } from '.';

export class EventDetailController implements ng.IComponentController {
   static $inject = ['gettextCatalog'];

   constructor(private gettextCatalog:nggt.gettextCatalog) { }

   event:EventDetail;

   get directionsUrl() {
      if (!this.event.directionsURL) {
         return this.buildDirectionsURL('address', 'city', 'stateCode', 'country', 'postalCode');
      } else {
         return this.event.directionsURL;
      }
   }

   private formatEventLocal(date:string, fmt:string) {
      return moment(date).tz(this.event.timezoneId).format(fmt);
   }

   private formatUserLocal(date:string, fmt:string) {
      let myTzId = moment.tz.guess();
      return moment(date).tz(myTzId).format(fmt);
   }

   get startWeekday() {
      return this.formatEventLocal(this.event.startDateTime, 'ddd');
   }

   get startDay() {
      return this.formatEventLocal(this.event.startDateTime, 'D');
   }

   get startMonth() {
      return this.formatEventLocal(this.event.startDateTime, 'MMM');
   }

   get eventLocalStartTime() {
      return this.formatEventLocal(this.event.startDateTime, 'LT zz');
   }

   get eventLocalEndTime() {
      return this.formatEventLocal(this.event.endDateTime, 'LT zz');
   }

   get isUserLocal() {
      let myTzId = moment.tz.guess();
      return moment.tz(myTzId).zoneAbbr() == moment.tz(this.event.timezoneId).zoneAbbr();
   }

   get userLocalStartTime() {
      return this.formatUserLocal(this.event.startDateTime, 'LT zz');
   }

   get userLocalEndTime() {
      return this.formatUserLocal(this.event.endDateTime, 'LT zz');
   }

   get language() {
      return this.gettextCatalog.getCurrentLanguage();
   }

   private buildDirectionsURL(...fields:string[]) {
      let components = _.filter(fields, prop => this.event[prop]);
      components = _.map(components, prop => this.event[prop]);
      return 'http://maps.google.com?q=' + encodeURIComponent(components.join(','));
   }
}

ng.module('selfReg').component('eventDetail', {
   templateUrl: require('./event-detail.html'),
   controller: EventDetailController,
   transclude: true,
   bindings: {
      event: '<'
   }
});
